import { render, staticRenderFns } from "./FormRegistro.vue?vue&type=template&id=22fac27e&scoped=true&"
import script from "./FormRegistro.vue?vue&type=script&lang=js&"
export * from "./FormRegistro.vue?vue&type=script&lang=js&"
import style0 from "./FormRegistro.vue?vue&type=style&index=0&id=22fac27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fac27e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VForm,VSelect,VSnackbar,VTextField})
